import { roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'
import NameValueTableRow from '../../ui-components/NameValueTableRow'
import { TaxInfo } from '../../../types/rebalance'
import { TaxCategories } from '../../../types/mutual-fund-detail.types'
import Info from '../../ui-components/Info'

type STCGProps = {
  stcgTaxInfo: TaxInfo
  taxCategory: `${TaxCategories}`
}

export default function STCG({ stcgTaxInfo, taxCategory }: STCGProps) {
  const getSTCGTitle = () => {
    if (
      [
        TaxCategories.HYBRID_NON_EQUITY,
        TaxCategories.NON_EQUITY,
        TaxCategories.DEBT,
        TaxCategories.HYBRID_DEBT
      ].includes(taxCategory as TaxCategories)
    ) {
      return `STCG Tax as per income <br /> tax slab @ 30%`
    }
    return `STCG Tax @ ${stcgTaxInfo.taxRate}%`
  }

  const getSTCGValueText = () => {
    if ([TaxCategories.HYBRID_NON_EQUITY, TaxCategories.NON_EQUITY].includes(taxCategory as TaxCategories)) {
      return `Investment held for less than 2Y`
    }
    if (
      [TaxCategories.EQUITY, TaxCategories.HYBRID_EQUITY, TaxCategories.ELSS].includes(taxCategory as TaxCategories)
    ) {
      return `Investment held for less than 1Y`
    }
    if ([TaxCategories.DEBT, TaxCategories.HYBRID_DEBT].includes(taxCategory as TaxCategories)) {
      return `Investments made on or after 1 Apr '23`
    }
    return 'Investment held for less than 1Y'
  }

  const getBottomDescription = () => {
    if (
      [
        TaxCategories.HYBRID_NON_EQUITY,
        TaxCategories.NON_EQUITY,
        TaxCategories.DEBT,
        TaxCategories.HYBRID_DEBT
      ].includes(taxCategory as TaxCategories)
    ) {
      return `Above calculation assumes a 30% tax slab to give you a conservative estimate. Actual tax may vary with your income bracket.`
    }
    return ''
  }
  return (
    <div className='flex flex-col gap-1'>
      <NameValueTableRow
        name={`${getSTCGTitle()}`}
        value={roundOffAndFormatNumberWithCurrency(stcgTaxInfo.taxableAmount).toString()}
        nameClassName='!text-[#095EB2] !font-[500] !text-[13px]'
        valueClassName='!text-[#095EB2] !text-[13px] !font-[500]'
      />
      <NameValueTableRow
        name={`${getSTCGValueText()}`}
        value={roundOffAndFormatNumberWithCurrency(stcgTaxInfo.investedAmount).toString()}
        nameClassName='!text-[#6A6E6E] !font-[400] !text-[13px]'
        valueClassName='!text-[#6A6E6E] !text-[13px] !font-[400]'
      />
      <NameValueTableRow
        name='Short term capital gains'
        value={
          `${stcgTaxInfo?.gains < 0 ? '-' : ''}` + roundOffAndFormatNumberWithCurrency(stcgTaxInfo.gains).toString()
        }
        nameClassName='!text-[#6A6E6E] !font-[400] !text-[13px]'
        valueClassName='!text-[#6A6E6E] !text-[13px] !font-[400]'
      />
      {getBottomDescription() && (
        <div>
          <Info lineClassName='border-l-2 border-[#6A6E6E]' className='' contentClassName='text-[#6A6E6E] text-[13px]'>
            {getBottomDescription()}
          </Info>
        </div>
      )}
    </div>
  )
}
